import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Navbar.css'

const links = [
  { to: '/', label: 'Home' },
  { to: '/galleria', label: 'Galleria' },
  // { to: '/info', label: 'Info Evento' },
  // { to: '/contatti', label: 'Contatti' },
]

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Chiude il menu con il tasto Esc
  useEffect(() => {
    if (!isMenuOpen) return
    const handleKey = (e) => e.key === 'Escape' && setIsMenuOpen(false)
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [isMenuOpen])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <header className={`site-header${isScrolled ? ' is-scrolled' : ''}`}>
        {/* Hamburger Icon */}
        <button type="button" onClick={toggleMenu} className="hamburger"
          aria-label="Apri menu" aria-expanded={isMenuOpen} aria-controls="main-menu">
          <span />
          <span />
          <span />
        </button>

        {/* Header with title */}
        <Link to="/" className="site-title">Back To The Roots</Link>
      </header>

      {/* Sidebar Menu */}
      <nav id="main-menu" aria-label="Menu principale"
        className={`sidebar${isMenuOpen ? ' is-open' : ''}`}>
        {/* Close Button (X) */}
        <button type="button" onClick={toggleMenu} className="sidebar-close" aria-label="Chiudi menu"
          tabIndex={isMenuOpen ? 0 : -1}>
          <span />
          <span />
        </button>
        <ul className="sidebar-links">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link to={to}
                className={`nav-link${location.pathname === to ? ' is-active' : ''}`}
                aria-current={location.pathname === to ? 'page' : undefined}
                tabIndex={isMenuOpen ? 0 : -1}
                onClick={toggleMenu}>{label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Overlay */}
      <div onClick={toggleMenu} className={`menu-overlay${isMenuOpen ? ' is-open' : ''}`} />
    </>
  )
}

export default Navbar
